const patient = {
  patients:'Pacientes',
  addNewPatients:'Añadir nuevos pacientes',
  critical:'Crítico',
  trending:'Tendencias',
  WNL:'WNL',
  watchList:'Lista de vigilancia',
  messages:'Mensajes',
  escalations:'Escalaciones',


demographics:{
  language:'Lenguaje Primario',
  otherLanguage:'Idioma Secundario',
  nickName:'Apodo',
  weight:'Peso',
  height:'Altura',
  preferredMethodofContact:'Método de contacto preferido',
  preferredTimeofDayforContact:'Hora preferida del día para el contacto',
  MRN:'MRN( Numero de historia CLINICA) ',
  suiteorApartment:'Suite o Apartamento',
  primaryFamilyMember:'Miembro principal de la familia',
  responsiblePerson:'Responsible Person',
  fullName:'Nombre completo',
  emailAddress:'Dirección de correo electrónico',
  emergencyContact:'Contacto de emergencia',
  sameAsPrimaryFamilyMemberInfo:'Igual que la información del miembro principal de la familia',
  sameAsResponsiblePersonInfo:'Same as Responsible Person info',
},

conditions:{
  healthConditions:'Condiciones de salud',
  A00:'Certain infectious and parasitic diseases (A00-B99)',
  C00:'Neoplasms (C00-D49)',
  E00:'Endocrine, nutritional and metabolic diseases (E00-E89)',
  F01:'Mental, Behavioral and Neurodevelopmental disorders (F01-F99 )',
  G00:'Diseases of the nervous system (G00-G99)',
  H00:'Diseases of the eye and adnexa (H00-H59)',
  H60:'Diseases of the ear and mastoid process(H60-H95)',
  I00:'Diseases of the circulatory system (I00-I99)',
  referralSource:'Referral Source (Assisted Living, Home Health, Cardiologist)',
  fax:'Fax',
  primaryPhysician:'Médico primario',
  sameAsabove:'Lo mismo que arriba'

},

programs:{
  program:'Programas',
  onboardinScheduledDate:'Fecha programada de incorporación',
  dischargeDate:'Fecha de alta'

},

devices:{
  deviceType:'Tipo de dispositivo',
  modelNo:'N º de Modelo',
  serialNo:'Número de serie',
  MACAddress:'Dirección MAC',
  deviceTime:'Hora del dispositivo',
  ServerTime:'Tiempo de Servidor'
},

parameters:{
  bloodPressure:'Presión sanguínea',
  systolic:'Sistólico',
  diastolic:'Diastólico',
  pulse:'Legumbres',
  BPM:'BPM',
  bloodOxygenSaturation:'Saturacion de oxigeno en sangre',
  SPO2:'SPO2',
  glucosen:'glucosa',
  FastingBloodSugar:'Glucemia en ayunas',
  randomBloodSugar:'Azúcar en la sangre al azar'
},

clinicalData:{
  medicalHistory:'Historial médico',
  medication:'Medicamento',
  medicine:'medicamento',
  frequency:'Frecuencia'
},

insurance:{
  insuranceNumber:'Numero de seguro',
  insuranceName:'Nombre del seguro',
  expirationDate:'Fecha de caducidad',
  secondaryInsurance:'Seguro secundario',
  tertiaryInsurance:'Seguro Terciario'


}


}


export default patient

